import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'
import $ from 'jquery'


const EMULATION_MODE_BRICKS = false


var SIMULATE_ERROR_RESP = { response: { status: 500 } }
var SIMULATE_BRICKS_ERROR = false
export function simulateBricksError (sim) {
    SIMULATE_BRICKS_ERROR = sim
}


/*
 * Brick Actions
 * 
 */

export function fetchBricksList(dispatch) {
    let cmd = 'FETCH_BRICKS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('ProductBricks');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_BRICKS_ERROR)                                   
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchBrickError(dispatch) {

    dispatch(
        {
            type: 'FETCH_BRICK_ERROR',
        }
    )
}

export function createBrick(brick) {
    let cmd = 'CREATE_BRICK'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: brick
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('ProductBricks'), JSON.stringify(brick), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchBrick(id) {
    let cmd = 'FETCH_BRICK'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductBricks/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_BRICKS_ERROR)                                   
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateBrick(id, brick) {
    let cmd = 'UPDATE_BRICK'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: brick
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('ProductBricks/') + id, JSON.stringify(brick), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_BRICKS_ERROR)
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateBrickValues(brick) {

    this.props.dispatch(
        {
            type: 'UPDATE_BRICK_VALUES_FULFILLED',
            payload: {
                data: brick
            }
        }
    )
}

export function exportBrickValues(id) {
    let cmd = 'EXPORT_BRICK_VALUES'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('ProductBricks/BrickValuesExport/') + id, {},
                {
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                    responseType: 'blob'
                })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )

                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');

                    link.href = url;
                    link.setAttribute('download', "BrickValues_Export.xlsx");

                    document.body.appendChild(link);
                    link.click();
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorBrick(dispatch) {

    dispatch(
        {
            type: 'BRICK_ERROR',
        }
    )
}

export function fetchAS400FieldNames(dispatch) {
    let cmd = 'FETCH_AS400_FIELD_NAMES'

    if (EMULATION_ALL || EMULATION_MODE_BRICKS)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('ProductBricks/AS400FieldNames');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_BRICKS_ERROR)
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function import_brick_excel(brickID, exactField, filter) {
    $('#create-edit-brick *').prop('disabled', true);

    let cmd = 'IMPORT_BRICK';

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('ProductBricks/BrickValueImport/'+ brickID + '/' + exactField), JSON.stringify(filter),
            {
                responseType: 'json', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onUploadProgress: progressEvent => {
                    dispatch(
                        {
                            type: cmd + '_PROGRESS',
                            payload: {
                                data: Math.round((progressEvent.loaded / progressEvent.total) * 100)
                            }
                        }
                    )
                }
            })
            .then((resp) => {
                if (resp.data == "Import Successful")
                    dispatch(
                        {
                            type: cmd + '_FULFILLED'
                        }
                    )
                else
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: resp.data
                        }
                    )

                setTimeout("document.getElementById('startImportBrick').style.display = 'none';", 1000);

                document.getElementById("fileChooseButtonBrick").value = null;
                $('#create-edit-brick  *').prop('disabled', false);
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function importError(err) {
    this.props.dispatch(
        {
            type: 'SET_IMPORT_ERROR',
            payload: {
                data: err
            }
        }
    )
}

export function errorImport(dispatch) {

    dispatch(
        {
            type: 'IMPORT_ERROR',
        }
    )
}
